"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConsultantInfoSlots = exports.default = exports.ConsultantInfo = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _consultantInfoClasses = require("./consultantInfoClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getConsultantInfoSlots = ownerState => {
  const {
    size
  } = ownerState;
  return {
    root: ['root', `size${(0, _utils.capitalize)(size)}`],
    consultantTitle: ['consultantTitle'],
    profilePicture: ['profilePicture'],
    consultantName: ['consultantName'],
    consultantNumber: ['consultantNumber'],
    content: ['content'],
    avatarIcon: ['avatarIcon']
  };
};
exports.getConsultantInfoSlots = getConsultantInfoSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getConsultantInfoSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _consultantInfoClasses.getConsultantInfoUtilityClass, classes);
  return composedClasses;
};
const ConsultantInfoRoot = (0, _material.styled)('div', {
  name: 'MuiOriConsultantInfo',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[`size${(0, _utils.capitalize)(ownerState.size)}`]]
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: 'auto auto 1fr',
  gridTemplateRows: 'auto auto auto auto',
  gap: theme.spacing(1, 4),
  gridTemplateAreas: `
        'profile-picture consultant-name    consultant-name'
        'profile-picture consultant-title   consultant-title'
        'profile-picture consultant-number  consultant-number'
        'profile-picture content            content'
        `,
  ...(ownerState.hasChild && {
    gridTemplateAreas: `
        'profile-picture consultant-name    consultant-name'
        'profile-picture consultant-title   consultant-title'
        'profile-picture content            content'
        `
  })
}));
const ProfilePicture = (0, _material.styled)(_material.Avatar, {
  name: 'MuiOriConsultantInfo',
  slot: 'ProfilePicture',
  overridesResolver: (_, styles) => [styles.profilePicture]
})(({
  theme,
  ownerState
}) => ({
  gridArea: 'profile-picture',
  alignSelf: 'start',
  width: 85,
  height: 85,
  backgroundColor: theme.palette.grey[100],
  fontSize: theme.typography.h3.fontSize,
  fontWeight: 'bold',
  ...(ownerState.size === 'large' && {
    width: 140,
    height: 140
  })
}));
const ConsultantName = (0, _material.styled)(_material.Typography, {
  name: 'MuiOriConsultantInfo',
  slot: 'ConsultantName',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.consultantName]
})(({
  theme,
  ownerState
}) => ({
  gridArea: 'consultant-name',
  alignSelf: 'start',
  ...(ownerState.size === 'large' && {
    fontSize: '3.5rem'
  })
}));
const ConsultantTitle = (0, _material.styled)(_material.Typography, {
  name: 'MuiOriConsultantInfo',
  slot: 'ConsultantTitle',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.consultantTitle]
})(({
  theme,
  ownerState
}) => ({
  gridArea: 'consultant-title',
  alignSelf: 'start',
  ...(ownerState.size === 'large' && {
    fontSize: '2rem'
  }),
  ...(ownerState.hasChild && {
    color: theme.palette.grey.A700,
    fontWeight: 'bold'
  })
}));
const ConsultantNumber = (0, _material.styled)(_material.Typography, {
  name: 'MuiOriConsultantInfo',
  slot: 'ConsultantNumber',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.consultantNumber]
})(({
  theme
}) => ({
  gridArea: 'consultant-number',
  color: theme.palette.grey.A700,
  alignSelf: 'start'
}));
const Content = (0, _material.styled)(_material.Typography, {
  name: 'MuiOriConsultantInfo',
  slot: 'Content',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.content]
})(({
  theme
}) => ({
  gridArea: 'content',
  paddingTop: theme.spacing(2),
  alignSelf: 'start'
}));
const Icon = (0, _material.styled)(_icons.UserFilled, {
  name: 'MuiOriConsultantInfo',
  slot: 'AvatarIcon',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.avatarIcon]
})(({
  theme,
  ownerState
}) => ({
  fontSize: '4rem',
  color: theme.palette.grey[500],
  ...(ownerState.size === 'large' && {
    fontSize: '7.5rem'
  })
}));
const ConsultantInfo = exports.ConsultantInfo = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriConsultantInfo'
  });
  const {
    profilePictureUrl,
    consultantName,
    consultantTitle,
    consultantNumber,
    className,
    size = 'medium',
    component = 'div',
    children,
    ...other
  } = props;
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    size,
    hasChild: Boolean(children)
  }), [props, size, children]);
  const classes = useUtilityClasses(ownerState);
  const imageProps = (0, _react.useMemo)(() => ({
    ownerState,
    className: classes.profilePicture,
    ...(profilePictureUrl && {
      alt: 'profile-picture',
      src: profilePictureUrl
    }),
    ...(!profilePictureUrl && {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        ownerState: ownerState,
        className: classes.avatarIcon
      })
    })
  }), [profilePictureUrl, classes, ownerState]);
  const consultantInfoTitle = (0, _react.useMemo)(() => {
    if (ownerState.hasChild) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ConsultantTitle, {
        ownerState: ownerState,
        className: classes.consultantTitle,
        children: [consultantTitle, " | ", consultantNumber]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ConsultantTitle, {
        ownerState: ownerState,
        className: classes.consultantTitle,
        children: consultantTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ConsultantNumber, {
        ownerState: ownerState,
        className: classes.consultantNumber,
        children: consultantNumber
      })]
    });
  }, [classes, consultantTitle, consultantNumber, ownerState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ConsultantInfoRoot, {
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    as: component,
    ...other,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ProfilePicture, {
      ...imageProps
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ConsultantName, {
      noWrap: true,
      ownerState: ownerState,
      className: classes.consultantName,
      variant: "h6",
      gutterBottom: false,
      children: consultantName
    }), consultantInfoTitle, children === null || typeof children === 'undefined' ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {
      as: "span",
      ownerState: ownerState,
      className: classes.content,
      children: children
    })]
  });
});
var _default = exports.default = ConsultantInfo;
